module.exports = __webpack_public_path__ + "img/arbre_5.13eaabf5.png";